<template>
    <b-container fluid>
        <b-card>
            <h4 class="card-title text-primary">{{ $t('org_pro.dynamic_form_builder') }}</h4>
            <div class="row">
                <div class="col-md-9">
                    <draggable
                        class="dragArea list-group"
                        :list="list2"
                        :move="checkMove"
                        group="people"
                        @change="log"
                    >
                        <div
                            class="list-group-item"
                            v-for="element in list2"
                            :key="element.name"
                        >
                            <table>
                                <tr>
                                    <th>name</th>
                                    <th>class</th>
                                    <th>variant</th>
                                </tr>
                                <tr>
                                    <td>
                                        <b-form-input autofocus="autofocus" v-model="element.name" class="mb-4"></b-form-input>
                                    </td>
                                    <td>
                                        <b-form-input v-model="element.className" class="mb-4"></b-form-input>
                                    </td>
                                    <td>
                                        <b-form-input v-model="element.variant" class="mb-4"></b-form-input>
                                    </td>
                                </tr>
                            </table>
                            <component :is="element.type"
                                       :value="element.name"
                                       :variant="element.variant"
                                       :className="element.className" />
                        </div>
                    </draggable>
                </div>

                <div class="col-md-3">
                    <h3>Select Input Field</h3>
                    <draggable
                        class="dragArea list-group"
                        :list="list1"
                        :group="{ name: 'people', pull: 'clone', put: false }"
                        @change="log"
                    >
                        <div
                            class="list-group-item"
                            v-for="element in list1"
                            :key="element.name"
                        >
                            <a href="#">
                                <span v-html="element.icon"></span> {{ element.name }}
                            </a>
                        </div>
                    </draggable>
                </div>

                <rawDisplayer class="col-3" :value="list2" title="List 2" />

                <rawDisplayer class="col-3" :value="list1" title="List 1" />
            </div>
        </b-card>
    </b-container>
</template>

<script>
import draggable from 'vuedraggable'
import DButton from './fields/Button'
import DCheckBox from './fields/CheckBox'
import DDateField from './fields/DateField'
import DFileInput from './fields/FileInput'
import DHeader from './fields/Header'
import DHiddenInput from './fields/HiddenInput'
import DInput from './fields/Input'
import DNumber from './fields/Number'
import DParagraph from './fields/Paragraph'
import DRadio from './fields/Radio'
import DSelect from './fields/Select'
import DTextArea from './fields/TextArea'

export default {
    name: 'clone',
    display: 'Clone',
    order: 2,
    components: {
        draggable, DButton, DCheckBox, DDateField, DFileInput, DHeader, DHiddenInput, DInput, DNumber, DParagraph, DRadio, DSelect, DTextArea
    },
    data () {
        return {
            list1: [
                // { name: 'Auto Complete', id: 1, icon: '<i class="ion-bowtie"></i>', type: 'autoComplete' },
                {
                    name: 'Button',
                    id: 2,
                    icon: '<i class="fas fa-grip-horizontal"></i>',
                    type: 'DButton',
                    variant: 'success',
                    className: ''
                },
                { name: 'Checkbox', id: 3, icon: '<i class="fas fa-tasks"></i>', type: 'DCheckBox' },
                { name: 'Date Field', id: 4, icon: '<i class="far fa-calendar-alt"></i>', type: 'DDateField' },
                { name: 'File Input', id: 5, icon: '<i class="fas fa-upload"></i>', type: 'DFileInput' },
                { name: 'Header', id: 6, icon: '<b class="font-size-16">H</b>', type: 'DHeader' },
                { name: 'Hidden Input', id: 7, icon: '<i class="far fa-keyboard"></i>', type: 'DHiddenInput' },
                { name: 'Number', id: 8, icon: '<i class="ion-pound"></i>', type: 'DNumber' },
                { name: 'Paragraph', id: 9, icon: '<i class="fas fa-paragraph"></i>', type: 'DParagraph' },
                { name: 'Radio', id: 10, icon: '<i class="far fa-list-alt"></i>', type: 'DRadio' },
                { name: 'Select', id: 11, icon: '<i class="fas fa-list-ol"></i>', type: 'DSelect' },
                { name: 'Input Field', id: 12, icon: '<i class="far fa-square"></i>', type: 'DInput' },
                { name: 'Text Area', id: 13, icon: '<i class="far fa-square"></i>', type: 'DTextArea' }
            ],
            list2: [
                { name: 'Auto Complete', id: 1, icon: '<i class="ion-bowtie"></i>', type: 'autoComplete' }
            ]
        }
    },
    methods: {
        checkMove (evt) {
            if (evt) {
              //
            }
        },
        log (evt) {
          if (evt) {
            //
          }
        }
    }
}
</script>
<style scoped></style>
